<template>
  <v-dialog v-model="show" width="500">
    <v-card>
      <v-card-title>
        <span class="headline">立替金帳票出力</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!allChoiced" @click="submit">{{$t('app.buttons.export')}}</v-btn>
        <v-btn @click="show=false">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-picker
                    :max="query.to"
                    :rules="[v => !!v || $t('app.labels.forecastDeliveryDate') + $t('app.validator.messages.required')]"
                    label="入力日"
                    v-model="query.from"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2>
                  <date-picker
                    :min="query.from"
                    :rules="[v => !!v || $t('app.labels.forecastDeliveryDate') + $t('app.validator.messages.required')]"
                    label="~"
                    v-model="query.to"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      query: {
        buId: null
      },
      resolve: null,
      reject: null
    }
  },
  computed: {
    allChoiced() {
      return this.query.from != null && this.query.to != null
    },
    currentMonthFirstDay() {
      var date = new Date()
      date.setDate(1)
      var month = parseInt(date.getMonth() + 1)
      var day = date.getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return date.getFullYear() + '-' + month + '-' + day
    },
    currentMonthLastDay() {
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      month = month < 10 ? '0' + month : month
      var day = new Date(year, month, 0)
      return year + '-' + month + '-' + day.getDate()
    }
  },
  methods: {
    popup() {
      this.show = true
      if (this.query.from == null && this.query.to == null) {
        this.$set(this.query, 'from', this.currentMonthFirstDay)
        this.$set(this.query, 'to', this.currentMonthLastDay)
      }
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    submit() {
      this.show = false
      this.resolve(this.query)
    }
  }
}
</script>
